// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bie_wx bie_jb bie_xl bie_i bie_j bie_q bie_vt bie_et bie_so bie_sp bie_eg","CommentsButton__icon":"il_b bie_rz"};